module.exports = __webpack_public_path__ + "img/section8-3-index.872e71dc.jpg";